// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"111":"f6c46454","366":"5f451797","510":"ff56a1c0","667":"824da40f","740":"9b8adc97","881":"dee4e87f","945":"28708f7e","983":"ee835f88"}[chunkId] + ".js";
};